import {
  Control,
  FieldErrors,
  UseFormRegister,
} from '@ltvco/refresh-lib/vendors';
import React from 'react';

import { SearchInput } from '../SearchInput';

import { OptionType } from './utils';

interface UnclaimedMoneyInputProps {
  register: UseFormRegister<{ name: string; states: OptionType[] }>;
  placeholder: string;
  errors: FieldErrors<{ name: string; states: OptionType[] }>;
  clearErrors: () => void;
  onClear: () => void;
  value: string;
  control: Control<{ name: string; states: OptionType[] }>;
}

export const UnclaimedMoneyInput = React.memo(
  ({
    register,
    placeholder,
    errors,
    clearErrors,
    onClear,
    value,
    control,
  }: UnclaimedMoneyInputProps) => {
    const registerReturn = register('name');

    return (
      <SearchInput
        registerReturn={registerReturn}
        label="Unclaimed Money"
        placeholder={placeholder}
        error={errors.name}
        clearErrors={clearErrors}
        onClear={onClear}
        value={value}
        control={control as unknown as Control}
        fieldName="name"
        autoFocus
      />
    );
  }
);
